import {
  WSButton,
  WSElement,
  WSElementProps,
  WSLoader,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";
import {
  BILLING_ATTACHMENT_LOAD_FAILED_LABEL,
  BILLING_ATTACHMENT_UNAVAILABLE_LABEL,
  useBillingAttachmentFile
} from "../../hooks/useBillingAttachmentFile";

type Props = {
  /** `BillingAttachment.memberFileId` — a VaultFile or a legacy MemberFile id. */
  fileId: string;
} & WSElementProps;

/**
 * Download link for one invoice/payable attachment, over either file space —
 * see `useBillingAttachmentFile`. Replaces the v1 `PublicAttachmentDownloadLink`
 * for invoices and payables (invoice templates still use it, being v1-only).
 */
export const BillingAttachmentDownloadLink: React.FC<Props> = ({
  fileId,
  ...elementProps
}) => {
  const file = useBillingAttachmentFile(fileId);

  return (
    <WSElement {...elementProps}>
      {file.isLoading ? (
        <WSLoader.Spinner size="S" />
      ) : file.isUnavailable || file.isLoadFailed ? (
        <WSText.ParagraphSm color="gray400">
          {file.isUnavailable
            ? BILLING_ATTACHMENT_UNAVAILABLE_LABEL
            : BILLING_ATTACHMENT_LOAD_FAILED_LABEL}
        </WSText.ParagraphSm>
      ) : (
        <WSButton.Link icon="download" onClick={file.download}>
          {file.filename ?? "Download"}
        </WSButton.Link>
      )}
    </WSElement>
  );
};
